import React, { Component } from "react";

import CustomerLogin from "./CustomerLogin";
import GuestLogin from "./GuestLogin";

class LoginSection extends Component {
	render() {
		return (
			<div>
				<div className="section-heading section--large-heading">
					<span className="txt">1</span>
					<span className="content">Welcome</span>
				</div>
				<div className="section-content">
					<div className="cart-login">
						<CustomerLogin />
					</div>

					<div className="cart-login guest-template">
						<GuestLogin />
					</div>
				</div>
			</div>
		);
	}
}

export default LoginSection;



// WEBPACK FOOTER //
// ./src/components/checkout/login/LoginSection.js